// courtesy of:
// https://developer.mozilla.org/en-US/docs/Web/API/Document/cookie#A_little_framework.3A_a_complete_cookies_reader.2Fwriter_with_full_unicode_support
module.exports = {
  getItem (sKey) {
    if (!sKey) {
      return null;
    }

    let encoded = encodeURIComponent(sKey).replace(/[-.+*]/g, '\\$&');
    let rxStr = `(?:(?:^|.*;)\\s*${encoded}\\s*\\=\\s*([^;]*).*$)|^.*$`;
    let value = document.cookie.replace(new RegExp(rxStr), '$1');

    return decodeURIComponent(value) || null;
  },

  setItem (sKey, sValue, vEnd, sPath, sDomain, bSecure) {
    if (!sKey || /^(?:expires|max-age|path|domain|secure)$/i.test(sKey)) {
      return false;
    }

    let sExpires = '';

    if (vEnd) {
      switch (vEnd.constructor) {
      case Number:
        sExpires = (vEnd === Infinity
                    ? '; expires=Fri, 31 Dec 9999 23:59:59 GMT'
                    : `; max-age=${vEnd}`);
        break;
      case String:
        sExpires = `; expires=${vEnd}`;
        break;
      case Date:
        sExpires = `; expires=${vEnd.toUTCString()}`;
        break;
      }
    }

    let key = encodeURIComponent(sKey);
    let value = encodeURIComponent(sValue);
    let domain = sDomain ? `; domain=${sDomain}` : '';
    let path = sPath ? `; path=${sPath}` : '';
    let secure = bSecure ? '; secure' : '';

    document.cookie = `${key}=${value}${sExpires}${domain}${path}${secure}`;

    return true;
  },

  removeItem (sKey, sPath, sDomain) {
    if (!this.hasItem(sKey)) {
      return false;
    }

    let key = encodeURIComponent(sKey);
    let expires = '; expires=Thu, 01 Jan 1970 00:00:00 GMT';
    let domain = sDomain ? `; domain=${sDomain}` : '';
    let path = sPath ? `; path=${sPath}` : '';

    document.cookie = `${key}=${expires}${domain}${path}`;

    return true;
  },

  hasItem (sKey) {
    if (!sKey) {
      return false;
    }

    let key = encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, '\\$&');

    return (new RegExp(`(?:^|;\\s*)${key}\\s*\\=`)).test(document.cookie);
  },

  keys () {
    let search = /((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g;
    let aKeys = document.cookie.replace(search, '').split(/\s*(?:\=[^;]*)?;\s*/);

    for (let nLen = aKeys.length, nIdx = 0; nIdx < nLen; nIdx++) {
      aKeys[nIdx] = decodeURIComponent(aKeys[nIdx]);
    }

    return aKeys;
  },
};



// WEBPACK FOOTER //
// ./lib/rlink-agegate/cookies.js